import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { SolicitudesService } from '../../../core/services/solicitudes.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-changeoptions-solicitud',
  templateUrl: './changeoptions-solicitud.component.html',
  styleUrls: ['./changeoptions-solicitud.component.css']
})
export class ChangeoptionsSolicitudComponent implements OnInit {

  header = '';
  message = '';
  tieneOriginalCopia = false;
  idSolicitud = 0;
  idCliente = 0;
  urgente = false;
  original = false;
  showModal = true;

  onClose = new Subject();
  onSaveCambios = new Subject<any>();

  loading = false;

  seleccionUrgenteNormal: string;
  seleccionOriginalCopia: string;

  constructor(
    private _bsModalRef: BsModalRef,
    // private solicitudService: SolicitudesService,
    private toastr: ToastrService,
  ) { }

  public ngOnInit(): void {
    this.onClose = new Subject();
  }

  showConfirmationModal(header, message, tieneOriginalCopia, idSolicitud, urgente, original) {
    this.header = header;
    this.message = message;
    this.tieneOriginalCopia = tieneOriginalCopia;
    this.idSolicitud = idSolicitud;
    this.urgente = urgente;
    this.seleccionUrgenteNormal = this.urgente ? 'urgente' : 'normal';
    this.original = original;
    this.seleccionOriginalCopia = this.original ? 'original' : 'copia';

  }

  public onCancel(): void {
    this.showModal = false;
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public onConfirm(): void {
    this.showModal = false;
    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  save() {
    this.loading = true;
    this.onSaveCambios.next( { normalurgente: this.seleccionUrgenteNormal == 'urgente', originalcopia: this.seleccionOriginalCopia == 'original' });
    // this.onSaveUrgenteNormal.next(this.seleccionUrgenteNormal == 'urgente');
    // this.onSaveOriginalCopia.next(this.seleccionOriginalCopia == 'original');
    this.onConfirm();
  }
}
